// import React, { useRef } from "react";
// import QRCode from 'react-qr-code';
// import styles from "./index.module.css";
// import Logo from "../../../assets/images/brand/login_logo.png";
// import Stamp from "../../../assets/images/brand/red_stamp.png";

// const QR_Link = process.env.REACT_APP_PUBLIC_QR_LINK;

// const formatDateWithSuperscript = (dateString) => {
//     if (!dateString) return '';

//     const parts = dateString.split(' ');

//     if (parts.length < 3) return dateString;

//     let day = parts[0].match(/\d+/)[0];
//     const suffix = parts[0].replace(/\d+/, '');
//     const month = parts[1];
//     const year = parts[2];

//     day = day.padStart(2, '0');

//     return { day, suffix, month, year };
// };

// const CertificateImage = ({ data }) => {
//     const certificateRef = useRef(null);

// const formattedDate = formatDateWithSuperscript(data?.completion_date);
// const formattedCertificateDate = formatDateWithSuperscript(data?.certificate_date);

//     return (
//         <div className={`main-card`}>
//             <div ref={certificateRef} className={styles.certificateContainer}>
//                 {/* Logo */}
//                 <img src={Logo} alt="Logo" className={styles.logo} />

//                 {/* Certificate Text */}
//                 <p className={styles.text}>This is to certify that</p>
//                 <p className={styles.studentName}>{data?.student_name}</p>
//                 <p className={styles.textSentence}>
//                     having fulfilled the conditions prescribed by the
//                 </p>
//                 <p className={styles.textSentence}>
//                     University is this day admitted to
//                 </p>
//                 <h3 className={styles.courseName}>{data?.course.name}</h3>
//                 <p className={styles.textSentence}>Given under the common seal of IBSUniversity</p>
//                 <p className={styles.textSentence}>on {formattedDate.day}<span className={styles.superScript}>{formattedDate.suffix}</span> {formattedDate.month} {formattedDate.year}</p>

//                 {/* Footer with Signatures, Stamp, and QR */}
//                 <div className={styles.footer}>
//                     <div style={{ textAlign: "center" }}>
//                         <p className={styles.signature}>VICE-CHANCELLOR</p>
//                         <p className={styles.signatureBottom}>CHANCELLOR</p>
//                     </div>
//                     <img src={Stamp} alt="Stamp" className={styles.stamp} />
//                     <div style={{ textAlign: "center" }}>
//                         <QRCode
//                             value={`${QR_Link}/document_ref/${data?.document_ref}`}
//                             size={80}
//                             className="code"
//                         />
//                         <p className={styles.qrText}>Scan to verify certificate.</p>
//                         <p className={styles.detailsText}>Document Ref.: {data?.document_ref}</p>
//                         <p className={styles.detailsText}>Completion Date: {formattedCertificateDate.day} {formattedCertificateDate.month} {formattedCertificateDate.year}</p>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CertificateImage;

import React, { useRef, useEffect } from "react";
import QRCode from 'react-qr-code';
import html2canvas from "html2canvas";  // Import html2canvas
import styles from "./index.module.css";
import Logo from "../../../assets/images/brand/login_logo.png";
import Stamp from "../../../assets/images/brand/star-stamp.png";
import Seal from "../../../assets/images/brand/Seal-removebg-preview.png";

const QR_Link = process.env.REACT_APP_PUBLIC_QR_LINK;

const formatDateWithSuperscript = (dateString) => {
    if (!dateString) return '';

    const parts = dateString.split(' ');

    if (parts.length < 3) return dateString;

    let day = parts[0].match(/\d+/)[0];
    const suffix = parts[0].replace(/\d+/, '');
    const month = parts[1];
    const year = parts[2];

    day = day.padStart(2, '0');

    return { day, suffix, month, year };
};

const CertificateImage = ({ data, onImageGenerated }) => {
    const certificateRef = useRef(null);
    const formattedDate = formatDateWithSuperscript(data?.completion_date);
    const formattedCertificateDate = formatDateWithSuperscript(data?.certificate_date);

    useEffect(() => {
        const generateImage = async () => {
            if (!certificateRef.current) return;

            const canvas = await html2canvas(certificateRef.current, {
                scale: window.devicePixelRatio, // Capture at higher resolution
                useCORS: true, // Prevent cross-origin issues
                logging: false,
            });

            const imgData = canvas.toDataURL("image/jpeg", 1.0);

            // Send the generated image to the parent component
            if (onImageGenerated) {
                onImageGenerated(imgData);
            }
        };

        setTimeout(generateImage, 500); // Delay to ensure the component is fully rendered
    }, []);

    return (
        // <div className={`main-card`}>
        <div ref={certificateRef} className={styles.certificateContainer} style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
            <img src={Logo} alt="Logo" className={styles.logo} />
            <p className={styles.text}>This is to certify that</p>
            <p className={styles.studentName}>{data?.student_name}</p>
            <p className={styles.textSentence}>
                having fulfilled the conditions prescribed by the
            </p>
            <p className={styles.textSentence}>
                University is this day admitted to
            </p>
            <h3 className={styles.courseName}>{data?.course.name}</h3>
            <p className={styles.textSentence}>Given under the common seal of IBSUniversity</p>
            <p className={styles.textSentence}>on {formattedCertificateDate.day}<span className={styles.superScript}>{formattedCertificateDate.suffix}</span> {formattedCertificateDate.month} {formattedCertificateDate.year}</p>
            {/* Footer with Signatures, Stamp, and QR */}
            <div className={styles.footer}>
                <div className={styles.sealContainer}>
                    <img src={Seal} alt="Seal" className={styles.sealImg} />
                    <p className={styles.signature}>VICE-CHANCELLOR</p>
                    <p className={styles.signatureBottom}>CHANCELLOR</p>
                </div>
                <img src={Stamp} alt="Stamp" className={styles.stamp} />
                <div style={{ textAlign: "center" }}>
                    <QRCode
                        value={`${QR_Link}/document_ref/${data?.document_ref}`}
                        size={70}
                        className="code"
                    />
                    <p className={styles.qrText}>Scan to verify certificate.</p>
                    <p className={styles.detailsText}>Document Ref.: {data?.document_ref}</p>
                    <p className={styles.detailsText}>Completion Date: {formattedDate.day} {formattedDate.month} {formattedDate.year}</p>
                </div>
            </div>
        </div>
        // </div>
    );
};

export default CertificateImage;